import { PublicationType, SavePublicationResultDto } from "generated/CoreApi_v1";
import * as React from 'react';
import { ClassifyList } from "views/knowledge/publication/classify/ClassifyList";
import { ClassifyPost } from "views/knowledge/publication/classify/ClassifyPost";
import { ClassifyQuestion } from "views/knowledge/publication/classify/ClassifyQuestion";
import { PublicationInAnswer, PublicationInListExclusive, PublicationInThread } from "views/knowledge/publication/creation";
import { MentionData } from "views/knowledge/publication/creation/components/PublicationEditor";
import { CreateAnswer } from "views/knowledge/publication/creation/CreateAnswer";
import { CreateList } from "views/knowledge/publication/creation/CreateList";
import { CreatePoll } from "views/knowledge/publication/creation/CreatePoll";
import { CreatePollThread } from "views/knowledge/publication/creation/CreatePollThread";
import { CreatePost } from "views/knowledge/publication/creation/CreatePost";
import { CreatePostListExclusive } from "views/knowledge/publication/creation/CreatePostListExclusive";
import { CreatePostThread } from "views/knowledge/publication/creation/CreatePostThread";
import { CreateQuestion } from "views/knowledge/publication/creation/CreateQuestion";
import { ClassifyPoll } from "../publication/classify/ClassifyPoll";


interface PublicationFactoryOptions {
    parent?: PublicationInThread | null;
    list?: PublicationInListExclusive | null;
    question?: PublicationInAnswer | null;
    mentions?: MentionData[];
    channelId?: string;
    topicId?: string;
    responderId?: string;
    responderName?: string;
    isPublic?: boolean;
}

export function publicationFactory(
    publicationId: string | null,
    publicationType: PublicationType,
    onClose: (result: SavePublicationResultDto | null) => void,
    options?: PublicationFactoryOptions
): React.ReactNode {

    switch (publicationType) {
        //    case PublicationType.Answer:
        //        return (<CreateAnswer answerId={publicationId} onClose={onClose} {...options} />);
        //    case PublicationType.Course:
        //        return (<CreateCourse publicationId={publicationId} onClose={onClose} {...options} />);
        case PublicationType.List:
            return (<CreateList
                publicationId={publicationId}
                onClose={onClose}
                channelId={options?.channelId}
                topicId={options?.topicId}
            />);

        case PublicationType.Poll:
            return (options?.parent)
                ? <CreatePollThread publicationId={publicationId} onClose={onClose} parent={options?.parent} />
                : <CreatePoll publicationId={publicationId} onClose={onClose} channelId={options?.channelId} topicId={options?.topicId} />;

        case PublicationType.Post:
            return (options?.parent)
                ? <CreatePostThread publicationId={publicationId} onClose={onClose} parent={options?.parent} />
                : (options?.list)
                    ? <CreatePostListExclusive publicationId={publicationId} list={options?.list} onClose={onClose} />
                    : <CreatePost publicationId={publicationId} channelId={options?.channelId} topicId={options?.topicId} onClose={onClose} />;

        case PublicationType.Question:
            return (<CreateQuestion
                publicationId={publicationId}
                mentions={options?.mentions}
                channelId={options?.channelId}
                topicId={options?.topicId}
                responderId={options?.responderId}
                responderName={options?.responderName}
                onClose={onClose}
            />);

        case PublicationType.Answer:
            return (<CreateAnswer
                publicationId={publicationId}
                question={options?.question}
                channelId={options?.channelId}
                topicId={options?.topicId}
                onClose={onClose}
            />);
    }

    //alert('Publication Factory cannot create publication type: ' + PublicationType[publicationType]);

    return null;
}

export function classifyFactory(
    publicationId: string,
    publicationType: PublicationType,
    title: string,
    onClose: (changed: boolean) => void,
): React.ReactNode {

    switch (publicationType) {
        case PublicationType.List:
            return <ClassifyList
                publicationId={publicationId}
                title={title}
                onClose={onClose}
            />;
        case PublicationType.Post:
            return <ClassifyPost
                publicationId={publicationId}
                title={title}
                onClose={onClose}
            />;
        case PublicationType.Poll:
            return <ClassifyPoll
                publicationId={publicationId}
                title={title}
                onClose={onClose}
            />;
        case PublicationType.Question:
            return <ClassifyQuestion
                publicationId={publicationId}
                title={title}
                onClose={onClose}
            />;
    }
    return null;
}
